import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storageInstance = getStorage()
const storageImages = ref(storageInstance, "trainersImages/");

export default {
    state:{
        trainersList: [],
        loadingStatusTrainerImage:0
    },
    mutations:{
        SET_TRAINERS_LIST(state, trainersList){
            state.trainersList = trainersList
        },
        SET_VALUE_LOADING_STATUS_TRAINER_IMAGE(state, progress) {
            state.loadingStatusTrainerImage = progress
        },
    },
    actions:{
                UploadImageTrainer({ commit }, trainer) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `trainersImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, trainer.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetTrainersList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "trainersList"))
                    const trainersList = []
                    querySnapshot.forEach((doc) =>  {
                        trainersList.push(doc.data())
                    })
                    commit('SET_TRAINERS_LIST', trainersList)
                    resolve(trainersList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateTrainer({}, trainer) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete trainer.image.img
                                         const newDocRef = doc(collection(db, "trainersList"));
                     trainer.id = newDocRef.id;
                     trainer.createdAt = new Date()
                     trainer.updatedAt = new Date()
                     await setDoc(newDocRef, trainer)
                     resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateTrainer({}, trainer) {
            return new Promise(async(resolve, reject) => {
                try {
                    if(trainer.createdAt) {
                        delete trainer.createdAt
                    }
                    trainer.updatedAt = new Date()
                    if (trainer.image.img) {
                        delete trainer.image.img
                    }
                                         await updateDoc(doc(db, "trainersList", trainer.id), trainer)
                     resolve(trainer.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteTrainer({}, trainer) {
            return new Promise(async(resolve, reject) => {
                try {
                                         let storageRefImage = ref(storageInstance, `trainersImages/${trainer.image.ref}`);
                    await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "trainersList", trainer.id))
                    resolve(trainer.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getTrainersList(state){
            return state.trainersList;
        },
        getLoadingStatusTrainerImage(state){
            return state.loadingStatusTrainerImage;
        },
    }
}